import React from "react";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import NavBar, { NavBarItem } from "../../../components/NavBar";
import "./PrototypeShared.css";

interface Comparativo {
  referencia: string;
  pesoReal: number;
  pesoTaxavel: number;
}

const comparativos: Comparativo[] = [
  { referencia: "CG-88213", pesoReal: 42.5, pesoTaxavel: 12.1 },
  { referencia: "CG-88220", pesoReal: 8.2, pesoTaxavel: 31.4 },
  { referencia: "CG-88231", pesoReal: 61.0, pesoTaxavel: 18.7 },
];

interface Consolidacao {
  cliente: string;
  armazem: string;
  cargas: number;
  janela: string;
}

const consolidacoes: Consolidacao[] = [
  { cliente: "GE Celma Matriz", armazem: "Cincinatti (CVG)", cargas: 4, janela: "mesma semana" },
  { cliente: "Baker Hughes", armazem: "Dallas (DFW)", cargas: 3, janela: "mesmos 3 dias" },
];

/**
 * Protótipo da aposta 4: otimização de frete (peso taxável × real) e consolidação.
 * O Painel Executivo (KPI 03) já mostra a média geral (1,4kg taxável x 37,6kg real) -
 * essa tela desceria pro nível de carga individual. Sem lógica de negócio nova.
 */
const OtimizacaoFreteView: React.FC = () => {
  const navItems: NavBarItem[] = [
    { label: "Início", route: "/", iconName: "house-door" },
    { label: "Iniciativas", route: "/iniciativas-estrategicas", iconName: "compass" },
  ];

  return (
    <Container fluid>
      <NavBar items={navItems} />
      <div className="mb-2"></div>

      <div className="proto-wrap">
        <Link to="/iniciativas-estrategicas" className="proto-back">← Iniciativas estratégicas</Link>

        <div className="proto-header">
          <div className="proto-badge">🧭 Protótipo — aposta 4 de 5</div>
          <h2>Otimização de frete: peso taxável e consolidação</h2>
          <p className="proto-subtitle">
            Compara peso volumétrico (o que o transportador cobra) com o peso real por carga, e aponta cargas do
            mesmo cliente/armazém numa janela curta que poderiam sair consolidadas.
          </p>
        </div>

        <div className="proto-section-title">Peso taxável × real, por carga</div>
        <div className="proto-mock">
          <div className="proto-mock-bar">
            <div className="proto-mock-dot"></div><div className="proto-mock-dot"></div><div className="proto-mock-dot"></div>
            <span className="proto-mock-title">giantlog.giantcargo.com.br/otimizacao-frete</span>
          </div>
          <div className="proto-mock-body" style={{ padding: 0 }}>
            <table className="proto-table">
              <thead>
                <tr>
                  <th>Referência</th>
                  <th>Peso real</th>
                  <th>Peso taxável</th>
                  <th>Cobrança provável</th>
                </tr>
              </thead>
              <tbody>
                {comparativos.map((c) => {
                  const usaTaxavel = c.pesoTaxavel > c.pesoReal;
                  return (
                    <tr key={c.referencia}>
                      <td style={{ fontFamily: "var(--mono)" }}>{c.referencia}</td>
                      <td>{c.pesoReal.toFixed(1)} kg</td>
                      <td>{c.pesoTaxavel.toFixed(1)} kg</td>
                      <td>
                        <span className={`proto-pill ${usaTaxavel ? "proto-pill-warn" : "proto-pill-ok"}`}>
                          {usaTaxavel ? "⚠️ pelo volumétrico" : "✓ pelo real (menor)"}
                        </span>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>

        <div className="proto-section-title">Oportunidades de consolidação</div>
        <div className="proto-cards">
          {consolidacoes.map((c) => (
            <div className="proto-card" key={c.cliente + c.armazem}>
              <div className="proto-card-top">
                <span className="proto-card-name">{c.cliente}</span>
                <span className="proto-pill proto-pill-ok">{c.cargas} cargas</span>
              </div>
              <div className="proto-card-row"><span>Armazém</span><b>{c.armazem}</b></div>
              <div className="proto-card-row"><span>Janela</span><b>{c.janela}</b></div>
            </div>
          ))}
        </div>

        <div className="proto-note">
          Dados ilustrativos. Fórmula real já calculada no Painel Executivo (KPI 03) a partir de Dimension
          (L×W×H×Qtd) e Cargo.Weight — essa tela desceria do agregado pra carga individual, cruzando com Cost.
        </div>

        <div className="proto-footer-nav">
          <Link to="/iniciativas-estrategicas/compliance-dgr">← Compliance e DGR</Link>
          <Link to="/iniciativas-estrategicas/score-cliente">Próxima: Score de saúde do cliente →</Link>
        </div>
      </div>
    </Container>
  );
};

export default OtimizacaoFreteView;
